import React, {
	useEffect, useState
} from 'react';
import {useTranslation} from "react-i18next";
import StatisticsRepository from "../../../repositories/StatisticsRepository";

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto'

import {
	Card,
	CardContent,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow, useTheme
} from "@material-ui/core";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";
import Typography from "@material-ui/core/Typography";
import FormLoading from "../../../components/FormLoading";
import {format} from "date-fns";
import moment from "moment";
import {DateRangeFilter} from "../../../components/DateRangeFilter";

const SuspiciousGraph = ({ dataTableClass }) => {

	const percentageFormatter = function(value) {
		return value + ' %';
	};

	const graphOptions = {
		responsive: true,
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
				ticks: {
					callback: percentageFormatter
				}
			}
		},
		plugins: {
			tooltip: {
				callbacks: {
					label: function(context) {
						let label = context.dataset.label || '';

						if (label) {
							label += ': ';
						}
						if (context.parsed.y !== null) {
							label += context.parsed.y + " %";
						}
						return label;
					}
				}
			}
		}
	};

	const today = format(new Date(), 'yyyy-MM-dd');
	const dateTo = today;
	const dateFrom = format(new Date(moment().add(-30, 'days')), 'yyyy-MM-dd');

	const repository = new StatisticsRepository();
	const {t}  = useTranslation();
	const [labels, setLabels] = useState([]);
	const [datasets, setDatasets] = useState([]);
	const [rows, setRows] = useState([]);
	const [isSearching, setIsSearching] = useState(false);
	const [filter, setFilter] = useState({ DateFrom: dateFrom, DateTo: dateTo });

	const classifierRepository = new StaticClassifierRepository();

	const dynamicColors = function(index) {
		const colors = ['rgba(255, 99, 132)',
			'rgb(54, 162, 235)',
			'rgb(255, 206, 86)',
			'rgb(75, 192, 192)',
			'rgb(153, 102, 255)',
			'rgb(255, 159, 64)'];

		return colors[index % colors.length];
	};

	const getData = async () => {
		setIsSearching(true);
		let result = await repository.getSuspiciousCameraEvents(filter);
		setIsSearching(false);

		setLabels(result.data.CameraNames);
		setRows(result.data.Items);

		let categories = [];
		for (let i in result.data.SuspiciousIds) {
			let suspiciousId = result.data.SuspiciousIds[i];

			let category = [];
			for (let j in result.data.CameraIds) {
				let cameraId = result.data.CameraIds[j];

				let rs = result.data.Items.filter(x => x.CameraId == cameraId && x.Suspicious == suspiciousId);

				if (rs.length > 0) {
					category.push(rs[0].SuspiciousPercentage);
				} else {
					category.push(0);
				}
			}
			categories.push({
				label: classifierRepository.getCameraEventSuspiciousStatusNameById(suspiciousId),
				data: category,
				backgroundColor: dynamicColors(i),
			});
		}

		setDatasets(categories);
	}

	useEffect(async() => {
		await getData();
    }, []);

	const mapSuspicious = (id) => {
		return classifierRepository.getCameraEventSuspiciousStatusNameById(id);
	}

	useEffect(async () => {
		await getData();
	}, [filter]);

	const data = {
		labels,
		datasets: datasets,
	};

	const onUpdateFilter = (filterData) => {
		setFilter(filterData);
	}

	return (

	<Card>
		<CardContent>
			<Typography gutterBottom variant="h2">
				{t('Suspicious events')}
			</Typography>
			{isSearching && <FormLoading />}

			<DateRangeFilter
				position={"relative"}
				value={filter.DateFrom && filter.DateTo ? { startDate: new Date(filter.DateFrom), endDate: new Date(filter.DateTo) } : null}
				onChange={e => {  onUpdateFilter({ 'DateFrom': format(e.startDate, 'yyyy-MM-dd'), 'DateTo': format(e.endDate, 'yyyy-MM-dd') }); }} />

			{rows.length > 0 && datasets && <Bar options={graphOptions} data={data} />}

		</CardContent>
	</Card>
	);
};

export default SuspiciousGraph;